import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('question-button', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('question-button');

      return new ViewModel(params, componentInfo);
    },
  },
  template: html,
});
